<div id="pag-div-1" class="container-paginator">
  <div id="pag-div-2" class="label-paginator copec-lg-14">
    <span id="pag-span-1" *ngIf="isSizeMobile">
      {{ currentPage }} de {{ totalPages }}</span
    >
    <span id="pag-span-2" *ngIf="!isSizeMobile"
      >Mostrando {{ currentPage }} de {{ totalPages }}</span
    >
  </div>
  <div id="pag-div-3"
    class="d-flex align-items-center justify-content-end container-button-paginator copec-rg-16"
  >
    <button id="pag-button-1" *ngIf="!isSizeMobile" (click)="firstPagePaginator()">
      <i id="pag-id-1" class="fa-solid fa-angles-left"></i>
    </button>
    <button (click)="prevPagePaginator()"><i class="fa-solid fa-angle-left"></i></button>
    <button id="pag-button-1-{{page}}"
      *ngFor="let page of buttonPages"
      (click)="onPageChangePaginator(page)"
      [ngClass]="{ selected: currentPage === page }"
    >
      {{ page }}
    </button>
    <button id="pag-button-2" (click)="nextPagePaginator()">
      <i class="fa-solid fa-angle-right"></i>
    </button>
    <button id="pag-button-3" *ngIf="!isSizeMobile" (click)="lastPagePaginator()">
      <i id="pag-id-2" class="fa-solid fa-angles-right"></i>
    </button>
  </div>
</div>
